<template>
  <div class="screenshots">
    <div class="screenshots__items">
      <div
        v-for="(item, index) in showedMedia"
        :key="item.src"
        class="screenshots__item"
        @click="openGallery(index)"
      >
        <img :src="item.thumb" alt="" />
        <div class="screenshots__item-date">{{ item.caption }}</div>
        <div class="screenshots__item-number">{{ index + 1 }}</div>
      </div>
    </div>

    <vbutton v-if="media.length > show" label="Показать еще" @click="show += 12" />
    <vbutton v-if="show > 12" label="Cвернуть" @click="show = 12" />
  </div>
</template>

<script>
  export default {
    props: {
      media: {
        type: Array,
        default: () => []
      }
    },

    data() {
      return {
        show: 6
      };
    },

    computed: {
      showedMedia() {
        return this.media.slice(0, this.show);
      }
    },

    methods: {
      openGallery(index) {
        this.$emit('open-gallery', index);
      }
    }
  };
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.screenshots {
  margin-top: 20px;
  margin-bottom: 50px;

  &__items {
    display: flex;
    flex-wrap: wrap;
  }

  &__item {
    margin-right: 15px;
    margin-bottom: 15px;
    position: relative;
    border-radius: 2px;
    cursor: pointer;
    border: 2px solid transparent;
    transition: border 0.2s;

    img {
      max-width: 210px;
      max-height: 180px;
      display: block;
      width: 100%;
      height: auto;
    }

    &:hover {
      border: 2px solid $green;
      transition: border 0.2s;
    }
  }

  &__item-date {
    position: absolute;
    max-width: 90%;
    bottom: 5px;
    left: 5px;
    background: rgba(0, 0, 0, 0.65);
    color: #fff;
    padding: 5px 8px;
    font-size: 10px;
  }

  &__item-number {
    position: absolute;
    max-width: 85%;
    top: 5px;
    left: 5px;
    background: rgba(0, 0, 0, 0.65);
    color: #fff;
    padding: 3px 5px;
    font-size: 10px;
  }
}
</style>
